import React from 'react';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';

function ModalConfirm({ handleClose, handleDeleteNew, show }) {
  const registering = useSelector(
    (state) => state.businessProfileReducers.isLoadingModal
  );

  function resetForm() {
    handleClose();
  }

  return (
    <>
      <ToastContainer autoClose={false} theme="colored" />
      <Modal show={show} onHide={handleClose} className="modal-filters">
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="text-center">Eliminar noticia</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <div>¿Está seguro que desea eliminar la noticia?</div>
            <div className="text-right buttons">
              <button
                type="button"
                className="btn btn-white-bg"
                disabled={registering}
                onClick={resetForm}
              >
                Cancelar
              </button>
              <button
                className="btn btn-primary"
                onClick={() => handleDeleteNew()}
              >
                Confirmar
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalConfirm;
